import { mapMutations, mapActions, mapGetters } from "vuex";
import { calculator } from "./../../../api/services/PriceCalculatorService";
import { calcLoyaltyPoints } from "../../../api/helpers/LoyalityHelper.js";
import { priceTriggerType } from "./../../../api/constants/priceTriggerEnums";
export default {
  computed: {
    ...mapGetters([
      "storeSupportsLoyaltyPoints",
      "currencySign",
      "showSharedCart",
      "getSharedCartProps",
      "currentStoreDoc",
    ]),
    price() {
      let sum = this.cartItem.price;
      if (this.cartItem.modifiers) {
        sum += calculator.modifierPrice(this.cartItem.modifiers);
      }
      return sum * this.cartItem.quantity;
    },
    discount() {
      var discount = 0;
      this.getPriceTriggerOutcomes
        .filter(
          (pt) =>
            pt.type == priceTriggerType.perItemDiscountPriceTriggers &&
            pt.order == this.cartItem.uniqueId
        )
        .forEach((element) => {
          discount += element.appliedDiscount;
        });
      if (discount === 0) return null;
      else return this.price - discount;
    },
    getPoints() {
      if (this.applicableLoyalityRule.length > 0) {
        var itemValue = this.discount ? this.discount : this.price;
        return calcLoyaltyPoints(this.applicableLoyalityRule, itemValue,this.cartItem.RewardPoint);
      } else return null;
    },
  },
  createdComponent(obj) {
    var numbers = new Array();
    for (var i = 1; i <= 20; i++) {
      numbers.push(i.toString());
    }
    obj.qtyNumbers = numbers;
    //test
  },
  methods: {
    ...mapMutations(["UpdateQuantity", "REMOVE_CART_ITEM", "confirmRollIntos","setActivePopupState"]),
    ...mapActions([
      "insertErrorlog",
      "applyPriceTriggers",
      "fixRollIntoQuantity",
    ]),
    getRollIntoPoints(rt) {
      if (this.applicableLoyalityRule.length > 0) {
        if (rt)
          return calcLoyaltyPoints(
            this.applicableLoyalityRule,
            rt.appliedDiscount
          );
      } else return null;
    },
    updateQt(event) {
      let qt;
      if(event.target)
        qt = parseInt(event.target.value);
      else
        qt = parseInt(event);

      if (!qt) {
        qt = 0;
      }
      this.UpdateQuantity({
        item: this.cartItem,
        quantity: qt,
        sharedcart: this.showSharedCart,
        user: this.getSharedCartProps.user,
        table: this.getSharedCartProps.table,
        storeId: this.currentStoreDoc.ID
      });
      this.applyPriceTriggers();
    },
    removeCartItem(item) {
      this.REMOVE_CART_ITEM({
        item: item,
        sharedcart: this.showSharedCart,
        user: this.getSharedCartProps.user,
        table: this.getSharedCartProps.table,
        storeId: this.currentStoreDoc.ID
      });
      this.applyPriceTriggers();
    },
    closeModal() {
      if (this.isWC()) this.$emit("change-sticky", false);
      this.$refs.rollIntoModal.hideModal();
      this.showRollInto = false;
    },
    selectRollIntoModiefiers(modifiers, index) {
      var rollIntos = this.toViewModel(this.rollInto.selectedRollIntos);

      if (modifiers.length <= 0) rollIntos.splice(index, 1);
      else {
        var find = rollIntos.find((p) => p.index == index);
        if (find) {
          find.modifiers = modifiers;
        } else {
          rollIntos.push({
            index: this.rollInto.selectedRollIntos.length,
            id: this.rollInto.ID,
            orderId: this.cartItem.uniqueId,
            rollInto: this.rollInto,
            modifiers: modifiers,
          });
        }
      }
      if (this.isWC()) this.$emit("change-sticky", false);
      this.$refs.rollIntoModal.hideModal();
      this.showRollInto = false;
      this.confirmRollIntos({
        rollIntos: rollIntos,
        id: this.rollInto.ID,
        orderId: this.cartItem.uniqueId,
      });
      this.applyPriceTriggers();
    },
    editRollInto(rollInto) {
      this.setActivePopupState(true);
      this.showRollInto = true;
      this.selectedIndex = rollInto.index;
    },
    initialModifier(index) {
      if (this.rollInto.selectedRollIntos[index]) {
        return this.rollInto.selectedRollIntos[index].selectedModifiers;
      }
      return null;
    },
    addrollInto() {
      this.setActivePopupState(true);
      this.showRollInto = true;
      this.selectedIndex = this.rollInto.selectedRollIntos.length;
    },
    toViewModel(models) {
      return models.map((roll, index) => {
        return {
          index: index,
          id: this.rollInto.ID,
          orderId: this.cartItem.uniqueId,
          rollInto: this.rollInto,
          modifiers: roll.selectedModifiers,
        };
      });
    },
    flatCartItemModifiers(modifiers) {
      var res = [
        ...modifiers.map((mo) => {
          return {
            ...mo,
            quantityDisplay: mo.quantity,
          };
        }),
      ];
      if (modifiers.flatMap) {
        var submod = modifiers.flatMap((x) => {
          if (x.selectedSubmodifiers)
            return x.selectedSubmodifiers.map((sb) => {
              return {
                ...sb,
                quantityDisplay: x.quantity * sb.quantity,
              };
            });
          else return x.selectedSubmodifiers;
        });
        submod.forEach((item) => {
          if (item) {
            res.push(item);
          }
        });
        return res;
      }
    },
  },
};
